import { useMemoryData } from "@crystal/core";
import { request } from "@crystal/http";
const featureFlagsBaseUrl = "https://feature-flags.adidas.com/api/publications";
const cacheStore = useMemoryData("crystal_featureFlagsCache", () => /* @__PURE__ */ new Map());
const promiseStore = useMemoryData("crystal_featureFlagsPromise", () => /* @__PURE__ */ new Map());
const envMap = {
  local: "development",
  dev: "development",
  stg: "staging",
  prod: "production"
};
async function loadFeatureFlagPublication(project, environment) {
  const cacheKey = getCacheKey(project, environment);
  const cacheData = cacheStore().get(cacheKey);
  if (cacheData)
    return cacheData;
  let promise = promiseStore().get(cacheKey);
  if (promise)
    return promise;
  const featureFlagsUrl = `${featureFlagsBaseUrl}/${project}/${envMap[environment]}`;
  promise = request(featureFlagsUrl).then((data) => cacheStore().set(cacheKey, data).get(cacheKey)).catch((err) => {
    promiseStore().delete(cacheKey);
    return Promise.reject(err);
  });
  promiseStore().set(cacheKey, promise);
  return promise;
}
function getCacheKey(project, environment) {
  return `${project}_${environment}`;
}
export {
  loadFeatureFlagPublication
};
//# sourceMappingURL=api.js.map
